import { HelpCircle } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { setHelpMenu } from '../Redux/store';

/**
 * HelpButton - Reusable help button that opens the help menu with a specific key
 * If no helpKey is provided, click returns early (for UI-only display purposes)
 */
export default function HelpButton({ helpKey }) {
  const dispatch = useDispatch();

  const handleClick = () => {
    if (!helpKey) return;
    dispatch(setHelpMenu(helpKey));
  };

  return (
    <button
      onClick={handleClick}
      className="flex h-9 w-9 items-center justify-center rounded-full bg-primary/10 text-primary hover:bg-primary/20"
    >
      <HelpCircle size={20} />
    </button>
  );
}
